import loadable from "@loadable/component"
import React from "react"

export default function PdfWrapper(props) {
  const Pdf = loadable(() => import("./Pdf"))
  return (
    <div>
      <Pdf {...props} />
    </div>
  )
}
